<template>
  <v-card flat tile :loading="isFpsLoading">
    <v-card-text class="py-0 px-1 my-auto mx-auto">
      <v-row justify="start" align-self="start" justify-self="start">
        <v-col cols="12">
          <vue-plyr :key="`plyr-${event.datetime}-${userId}`" :ref="`plyr-${event.datetime}-${userId}`"
                    :emit="['loadeddata', 'canplay', 'ended']"
                    @ended="$emit('video-ended')"
                    @canplay="playerReady" :options="videoOptions">
            <video playsinline controls class="videoHeight">
              <source :src="videoSource" type="video/mp4">
            </video>
          </vue-plyr>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import VuePlyr from 'vue-plyr'
import { CriticalEvent } from '@/models/map/CriticalEvent'
import { getSite } from '@/utils/path'
import backend from '@/backend'
import { UploadVideoTypes } from '@/enum'
import { videoSeekSeconds } from '@/utils/time'

const seekSeconds = videoSeekSeconds
const defaultSeekTime = 0.1

const generateVideoControls = (options) => {
  const controls = []

  if (options.fetchFps) {
    controls.push('rewind')
  }

  controls.push('play')

  if (options.fetchFps) {
    controls.push('fast-forward')
  }

  return [...controls, ...[
    'progress',
    'current-time',
    'duration',
    'volume',
    'settings',
    'download',
    'fullscreen'
  ]]
}

export default {
  name: 'criticalVideo',
  components: {
    VuePlyr
  },
  props: {
    event: CriticalEvent,
    userId: Number,
    videoType: {
      type: String,
      default: UploadVideoTypes.DRIVER
    },
    isForcedVideo: {
      type: Boolean,
      default: false
    },
    isAutoPlay: {
      type: Boolean,
      default: false
    },
    fetchFps: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      isFirstVideoCheck: false,
      isFpsLoading: false,
      videoOptions: {
        controls: generateVideoControls({ fetchFps: this.fetchFps }),
        seekTime: defaultSeekTime,
        muted: true
      }
    }
  },
  methods: {
    playerReady () {
      if (!this.isFirstVideoCheck) {
        this.$nextTick(() => {
          if (this.isForcedVideo) {
            this.$refs[this.playerRef].player.currentTime = seekSeconds
          }

          if (this.isAutoPlay) {
            this.$refs[this.playerRef].player.play()
          }

          try {
            this.$emit('media-duration', this.$refs[this.playerRef].player.media.duration)
          } catch (e) {
            console.error(e)
          }

          this.isFirstVideoCheck = true
        })
      }
    },
    setDuration (value) {
      this.$refs[this.playerRef].player.currentTime = value
    },
    playVideo () {
      this.$refs[this.playerRef].player.play()
    },
    stopVideo () {
      this.$refs[this.playerRef].player.stop()
    }
  },
  computed: {
    changedVideo () {
      return [this.userId, this.event.datetime.getTime()]
    },
    playerRef () {
      return `plyr-${this.event.datetime}-${this.userId}`
    },
    videoSource () {
      return `${getSite()}map/critical_video?user=${this.userId}&timestamp=${this.event.datetime.getTime()}&video_type=${this.videoType}`
    }
  },
  watch: {
    changedVideo: {
      immediate: true,
      async handler (value) {
        if (this.fetchFps) {
          this.isFpsLoading = true

          try {
            const fps = await backend.checkCriticalVideoFps({
              user: String(this.userId),
              timestamp: String(this.event.datetime.getTime()),
              'video_type': this.videoType
            })

            this.videoOptions.seekTime = 1 / fps.data
          } catch (e) {
            console.error(e)
            this.videoOptions.seekTime = defaultSeekTime
          } finally {
            this.isFpsLoading = false
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.videoHeight {
  /*max-height: 450px;*/
}
</style>
